// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ResizeObserver$Showside from "../utils/ResizeObserver.bs.js";
import * as UseInlineHelper$Showside from "../hook/UseInlineHelper.bs.js";
var context = React.createContext({
  embedContainer: undefined,
  embedOffsetTop: undefined
});
var provider = context.Provider;
function InlineContainerContext$Provider(Props) {
  var embedRef = Props.embedRef;
  var children = Props.children;
  var embedSize = ResizeObserver$Showside.useResizeObserver(true, embedRef);
  var embedOffsetTop = Belt_Option.map(embedSize, function (size) {
    return size.top;
  });
  var embedHeight = Belt_Option.map(embedSize, function (size) {
    return size.height;
  });
  var embedContainer = embedRef.current;
  var embedContainer$1 = embedContainer == null ? undefined : Caml_option.some(embedContainer);
  UseInlineHelper$Showside.useInlineHelper(embedContainer$1, embedHeight, embedOffsetTop);
  return React.createElement(provider, {
    value: {
      embedContainer: embedContainer$1,
      embedOffsetTop: embedOffsetTop
    },
    children: children
  });
}
InlineContainerContext$Provider.displayName = "InlineContainerContext.Provider";
var Provider = {
  provider: provider,
  make: InlineContainerContext$Provider
};
function use(param) {
  return React.useContext(context);
}
export { context, Provider, use };
/* context Not a pure module */